import React from 'react';
import { useSelector } from 'react-redux';
import { selectLiveArea } from 'redux/lodgeEnquiry/selectors';
import { Tag } from 'carbon-components-react';

export const LiveAreaTag: React.FC<Props> = ({ activeTool, isSmallScreen }) => {
  const liveArea = useSelector(selectLiveArea);

  return (
    <>
      {liveArea !== undefined && (
        <div className="live-area-tag">
          <Tag type="high-contrast" title="Live area">
            {activeTool === 'polyline' ? (
              <>
                {!isSmallScreen ? 'LENGTH ' : ''}
                <span className="value">
                  {liveArea > 1
                    ? `${liveArea.toFixed(2)} km`
                    : `${Number(liveArea * 1000).toFixed(2)} m`}
                </span>
              </>
            ) : (
              <>
                {!isSmallScreen ? 'LIVE AREA ' : ''}
                <span className="value">
                  {liveArea > 0.01
                    ? `${liveArea.toFixed(2)} km²`
                    : `${Number(liveArea * 1e6).toFixed(2)} m²`}
                </span>
              </>
            )}
          </Tag>
        </div>
      )}
    </>
  );
};

type Props = {
  activeTool: string;
  isSmallScreen: boolean;
};

export default React.memo(LiveAreaTag);
